import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useRouter } from 'next/router'
import { connect, useDispatch } from 'react-redux'
import { SAVE_PRISMIC_DOCUMENTS } from '../../redux/actions/prismic'
import {
  deletePackOrigin,
  getPacksByPackTaxonId,
  getPackTaxons,
  saveCurrentPack,
} from '../../redux/actions/packs'
import Loader from '../../components/Loader/Loader'
import Layout from '../../components/Layout/Layout'
import {
  calcPackMinPrice,
  columnGridLayout,
  setFullLocale,
  thumbnailRatio,
  btnOptions,
  columnLayout,
} from '../../utils/utils'
import { getTranslations } from '../../i18n'
import useShopStyle from '../../components/Shop/Shop.style'
import {
  Container,
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import HeroSection from '../../components/Hero/HeroSection'
import ImgKitHandler from '../../components/ImgKitHandler/ImgKitHandler'
import Skeleton from '@material-ui/lab/Skeleton'
import Button from '../../components/Button/Button'
import { KeyboardArrowLeft } from '@material-ui/icons'
import DateRangeForm from '../../components/DateRangeForm/DateRangeForm'
import PackProductCard from '../../components/Packs/PackProductCard'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import SizeModal from '../../components/Sizes/SizeModal'
import { usePackAvailability } from '../../utils/usePackAvailability'
import CMSText, { prismicText } from '../../components/Global/CMSText'
import BottomMenuLinks from '../../components/Shop/BottomMenuLinks'
import CommonInformations from '../../components/Shop/CommonInformations'
import ChangeStoreModal from '../../components/InStore/ChangeStoreModal'
import InStoreSoldOut from '../../components/InStore/InStoreSoldOut'
import PackPriceFormat from '../../components/Packs/PackPriceFormat'
import PackRelatedProducts from '../../components/Packs/PackRelatedProducts'
import BackInStockAlert from '../../components/BackInStockAlert/BackInStockAlert'
import { shortProduct, StockUnit } from '../../typings/base'
import { isSubscription } from '../../utils/constants'
import { PackInterface } from '../../interfaces/packs/packInterface'
import { PackAdapter } from '../../redux/adapter/packs/packAdapter'
import NoMixedBasketModal from '../../components/Products/NoMixedBasketModal'
import { useCart } from '../../hooks/useCart'
import { createClient, getSingleDocument } from '../../prismicio'
import { GetMapDispatchTypes } from '../../interfaces/common/redux'
import { RootState } from '../../redux/reducers/rootReducer'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    prev: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    main: {
      padding: theme.spacing(3, 0),
    },
    loadingImg: {
      display: 'block',
      maxWidth: '100%',
      height: 480,
      borderRadius: theme.shape.borderRadius,
    },
    imgShape: {
      borderRadius: theme.shape.borderRadius,
    },
    skeletonText: {
      transform: 'none',
    },
    packHead: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: theme.spacing(2),
    },
    packContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      padding: theme.spacing(1, 0, 2),
      [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(3),
      },
    },
    desc: {},
    packProductTitle: {
      marginBottom: theme.spacing(3),
    },
    relatedTitle: {
      margin: theme.spacing(0, 0, 2),
    },
    col: {},
    md5: {
      [theme.breakpoints.up('lg')]: {
        maxWidth: '20%',
        flexBasis: '20%',
      },
    },
    associationRow: {
      marginBottom: theme.spacing(3),
    },
  })
)

type TProps = {
  packs: any
  taxonPack: any
  parameters: any
  getPackTaxons: any
  getPacksByPackTaxonId: any
  generalRes: any
  funnel: any
  inStoreText: any
  packSettings: any
  promotions: any
  cart: any
  packsTexts: any
  stock: any
  saveCurrentPack: any
  takeback: any
  basket: any
  deletePackOrigin: () => void
  singleProductRes: any
  stores: any
  accountRes?: any
  faqRes?: any
  banner?: any
} & ReturnType<typeof mapStateToProps> &
  GetMapDispatchTypes<typeof mapDispatchToProps>

const mapStateToProps = (state: RootState) => ({
  packs: state.packs,
  taxonPack: state.taxonPack,
  parameters: state.parameters,
  promotions: state.promotions,
  cart: state.cart,
  stock: state.stock,
  stores: state.stores,
  takeBackLP: state.takeBack,
})

const mapDispatchToProps = {
  getPackTaxons: getPackTaxons,
  getPacksByPackTaxonId: getPacksByPackTaxonId,
  saveCurrentPack: saveCurrentPack,
  deletePackOrigin: deletePackOrigin,
}

const Pack = ({
  packs,
  taxonPack,
  getPackTaxons,
  getPacksByPackTaxonId,
  generalRes,
  funnel,
  inStoreText,
  parameters,
  packSettings,
  takeback,
  promotions,
  cart,
  packsTexts,
  stock,
  saveCurrentPack,
  deletePackOrigin,
  basket,
  singleProductRes,
  stores,
  accountRes,
  faqRes,
  banner,
  takeBackLP,
}: TProps) => {
  const { addMultipleProductToCart } = useCart()
  const LayoutStyle = {}
  const classes = useShopStyle(LayoutStyle)
  const packClasses = useStyles()
  const theme = useTheme()
  const router = useRouter()
  const { t } = useTranslation()
  const { trackEvent, trackPageView } = useMatomo()
  const currentSlug = router.query.pack
  const [currentUrl, setCurrentUrl] = useState('')
  const [fromApp, setFromApp] = useState(true)
  const [packLoading, setPackLoading] = useState(true)
  const [currentPack, setCurrentPack] = useState<PackInterface>()
  const [minPrice, setMinPrice] = useState(0)
  const [openModal, setOpenModal] = useState(false)
  const [openInStoreModal, setOpenInStoreModal] = useState(false)
  const [selection, setSelection] = useState([])
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const displayHero = packSettings?.data?.display_hero_section
  const thumbWidth = generalRes?.data?.small_image_size
  const cardWidth = generalRes?.data?.medium_image_size
  const largeImgWidth = generalRes?.data?.large_image_size
  const aspectRatio = thumbnailRatio(generalRes?.data.thumbnail_ratio)
  const { columnLeft, columnRight } = columnGridLayout(
    packSettings?.data?.column_layout
  )
  const packFullyLoaded = currentPack !== undefined

  const packState = usePackAvailability(
    generalRes?.data?.add_pack_if_complete,
    currentPack?.packProducts,
    stock
  )
  const discountPriceFormat = generalRes?.data?.discounted_price_display_format
  const addToCartBtnOpts = btnOptions(packSettings?.data?.add_to_cart_button)
  const showRelatedProducts = packSettings?.data?.display_associations
  const addToCartButtonOnAssociatedItem =
    packSettings?.data?.display_add_to_cart_button_on_associated_item
  const associations = currentPack && currentPack.productsAssociations
  const relatedProductsTitle = packSettings?.data?.association_text
  const gridItemWidth = columnLayout(generalRes?.data.page_shop_desktop_columns)
  const isFiveColumns = gridItemWidth === '20%'
  const isEnableChooseStartingDate = parameters?.items?.enableChooseStartingDate
  const baseUrl =
    typeof window !== 'undefined' && window.location.origin
      ? window.location.origin
      : ''
  const warehouseId = stores?.selectedStore?.warehouseId
    ? stores?.selectedStore?.warehouseId
    : process.env.CUSTOM_WAREHOUSE
    ? process.env.CUSTOM_WAREHOUSE
    : null

  const currentFullUrl = baseUrl + router.asPath

  //For now the stock alert is made only for sub stores
  const showStockAlert = isSubscription
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(
      SAVE_PRISMIC_DOCUMENTS({
        general: generalRes?.data,
        instore: inStoreText?.data,
      })
    )
  }, [generalRes, inStoreText])

  useEffect(() => {
    if (router.isReady) {
      setCurrentUrl(router.asPath)
    }
  }, [router.isReady])

  useEffect(() => {
    // If the single pack is visited on first page load, we need to fetch all the pack with help of pack taxons
    if (!taxonPack.items) {
      getPackTaxons()
    } else {
      if (packs?.origin !== 'packs') {
        const fetchAllPacks = async () => {
          for (const item of taxonPack.items) {
            const packsLoaded = await getPacksByPackTaxonId(item.id)
            const filteredPack = packsLoaded?.packs?.filter(
              (pack) => pack.slug === currentSlug
            )
            if (filteredPack.length > 0) {
              setCurrentPack(PackAdapter(filteredPack[0]))
              saveCurrentPack(filteredPack)
              break
            }
          }
        }

        fetchAllPacks()
        setPackLoading(false)
      } else {
        setCurrentPack(packs?.items?.find((el) => el.slug === currentSlug))
        setPackLoading(false)
        deletePackOrigin()
      }
    }
  }, [currentSlug, taxonPack.items])

  useEffect(() => {
    if (currentPack) {
      const minPrice = calcPackMinPrice(currentPack?.packProducts)
      setMinPrice(minPrice)
      trackPageView({ documentTitle: currentPack.name })
    }
  }, [currentPack, promotions?.currentPromotion])

  useEffect(() => {
    // Turns out that opening a tab start your history at 1
    if (window.history.length <= 2) {
      setFromApp(false)
    }
  }, [fromApp])

  const handleBack = () => {
    fromApp ? router.back() : router.push('/packs')
  }

  // add pack with all variants
  const AddMultipleProductsToCart = async (selection) => {
    // add selection to cart
    trackEvent({
      category: 'Packs',
      action: `Add products to cart from single pack : ${currentPack?.name}`,
    })
    await addMultipleProductToCart({ items: selection })
    setSelection([])
    setOpenModal(false)
  }

  const handleCloseInStoreModal = () => {
    setOpenInStoreModal(false)
  }

  const handleOpenInStoreModal = () => {
    setOpenInStoreModal(true)
  }

  const currentPackSKUs: string[][] =
    currentPack &&
    currentPack.packProducts.map((unit) => {
      const productSKU =
        unit.product.variants?.length === 1
          ? [unit.product.variants[0].sku]
          : unit.product.variants?.map((variant) => {
              return variant.sku
            })
      return productSKU
    })

  const shortProducts: shortProduct[] = stock?.stock
    ?.filter((stockUnit: StockUnit) => {
      for (let i = 0; i < currentPackSKUs?.length; i++) {
        if (currentPackSKUs[i]?.includes(stockUnit.lizeeSKU)) {
          return stockUnit
        }
      }
    })
    .map((unit) => {
      return {
        sku: unit.lizeeSKU,
        quantity: unit.quantity,
      }
    })

  const PackAddToCart = () => (
    <>
      {!packState.soldOut ? (
        <div className={'pack-choose-button'}>
          <Button
            onClick={() => setOpenModal(true)}
            color="secondary"
            variant={'contained'}
            size={isMobile ? 'small' : 'medium'}
            data-testid={'pack-choose-button'}
            className={'pack-choose-button'}
            disabled={
              (currentPack && currentPack.packProducts.length === 0) ||
              cart.loading
            }
          >
            <CMSText
              asText
              data={packSettings?.data?.choose_button}
              defaultText={t('texts:pack_single:choose')}
            />
          </Button>
        </div>
      ) : (
        <>
          {!parameters?.items?.in_store ? (
            <Typography
              variant={'h4'}
              component={'h2'}
              className={clsx(
                'pack__unavailable',
                `pack__unavailable__${currentPack?.code}`
              )}
            >
              <CMSText
                asText
                data={packSettings?.data?.sold_out}
                defaultText={t('texts:pack_single:sold_out')}
              />
            </Typography>
          ) : (
            <InStoreSoldOut
              datas={inStoreText}
              isPack
              handleOpenInStoreModal={handleOpenInStoreModal}
              defaultText={{
                title: t('texts:instore:pack_not_available'),
                desc: t('texts:instore:paragraph'),
                cta: t('texts:instore:change_store_cta'),
              }}
            />
          )}
          {showStockAlert && (
            <BackInStockAlert
              singleProductPrismicData={singleProductRes?.data}
              products={shortProducts}
              url={currentFullUrl}
              warehouseId={warehouseId}
              isPack
            />
          )}
        </>
      )}
    </>
  )

  const PackDesc = () => (
    <div>
      <Typography
        variant="body1"
        component={'div'}
        className={clsx('pack__desc', classes.shopApiContent, packClasses.desc)}
      >
        {packFullyLoaded ? (
          <div
            dangerouslySetInnerHTML={{
              __html: currentPack?.description,
            }}
          />
        ) : (
          /* Loading Paragraphs */
          Array.from(new Array(12)).map((el, index) => {
            return (
              <Skeleton
                key={index + 1}
                variant="text"
                width={`${Math.floor(Math.random() * 100) + 1}%`}
              />
            )
          })
        )}
      </Typography>
    </div>
  )

  return packLoading ? (
    <Loader />
  ) : (
    <Layout
      mainLogo={generalRes?.data?.logo}
      t={t}
      doc={generalRes}
      inStoreText={inStoreText}
      metaTitle={currentPack?.name}
      basket={basket}
      takeback={takeback}
      account={accountRes}
      faq={faqRes}
      banner={banner}
      //   metaDescriptionProduct={product?.item?.metaDescription}
      //   metaKeywordsProduct={product?.item?.metaKeywords}
    >
      <main className={clsx(classes.root, 'page--pack')}>
        {!isMobile && !displayHero && (
          <HeroSection
            title={prismicText(
              generalRes?.data?.baseline,
              t('texts:general:baseline')
            )}
            heroImg={generalRes?.data?.hero_banner}
            heroSettings={generalRes?.data}
          />
        )}
        <section
          className={clsx(
            'pack__content',
            classes.shopContent,
            classes.shopContentSingle
          )}
        >
          <Container
            maxWidth="xl"
            className={clsx('product__container', classes.shopContainer)}
          >
            {(!isSubscription && !isMobile && !displayHero) ||
              (isEnableChooseStartingDate && (
                <div
                  className={clsx(
                    'shop__planner',
                    classes.shopPlanner,
                    classes.shopPlannerDad
                  )}
                >
                  <DateRangeForm
                    text={generalRes?.data}
                    textFunnel={funnel?.data}
                    t={t}
                    parameters={parameters}
                    scrollTarget={'pack-single'}
                  />
                </div>
              ))}
            <Container
              maxWidth="xl"
              className={clsx(
                'product__area',
                classes.shopArea,
                classes.shopAreaSingle
              )}
              id={'pack-single'}
            >
              <Button
                className={clsx('pack__prev', packClasses.prev)}
                variant="outlined"
                color="secondary"
                onClick={() => handleBack()}
                size="small"
                startIcon={<KeyboardArrowLeft />}
              >
                <CMSText
                  asText
                  data={generalRes?.data?.previous_button}
                  defaultText={t('texts:general:previous_button')}
                />
              </Button>
              <Grid
                container
                className={clsx('pack__main', packClasses.main)}
                spacing={isMobile ? 4 : 8}
                data-testid={packFullyLoaded ? 'pack-loaded' : 'pack-loading'}
              >
                {packFullyLoaded && currentPack.images?.length > 0 && (
                  <Grid item className="pack__left" {...columnLeft}>
                    <div data-ratio={aspectRatio}>
                      {packFullyLoaded ? (
                        <ImgKitHandler
                          classes={clsx('pack__image', packClasses.imgShape)}
                          imagePaths={currentPack.images[0]}
                          settings={{
                            quality: 75,
                            width: largeImgWidth,
                            ar: aspectRatio?.substring(3),
                          }}
                        />
                      ) : (
                        <Skeleton
                          variant="rect"
                          className={packClasses.loadingImg}
                        />
                      )}
                    </div>
                  </Grid>
                )}
                <Grid
                  item
                  className="pack__right"
                  {...(packFullyLoaded && currentPack.images?.length > 0
                    ? { ...columnRight }
                    : { xs: 12 })}
                >
                  <div
                    className={clsx('pack__content', packClasses.packContent)}
                  >
                    <div className={clsx('pack__head', packClasses.packHead)}>
                      <div className="pack__title">
                        <Typography variant={'h2'} component={'h1'}>
                          {packFullyLoaded ? (
                            <>{currentPack?.name}</>
                          ) : (
                            <Skeleton
                              variant="text"
                              className={packClasses.skeletonText}
                            />
                          )}
                        </Typography>
                      </div>
                      <div
                        className={clsx(
                          'pack__price',
                          `pack__price__${currentPack?.code}`
                        )}
                      >
                        <PackPriceFormat
                          promotions={promotions}
                          settings={generalRes?.data}
                          minPrice={minPrice}
                          discountPriceFormat={discountPriceFormat}
                          isDisplayPercentage
                        />
                      </div>
                    </div>
                    {addToCartBtnOpts === 'Both' && <PackAddToCart />}
                    {addToCartBtnOpts === 'Above' && <PackAddToCart />}

                    <PackDesc />

                    {addToCartBtnOpts === 'Both' && <PackAddToCart />}
                    {addToCartBtnOpts === 'Below' && <PackAddToCart />}
                    <div className={`commonInformations__${currentPack?.code}`}>
                      <CommonInformations
                        datas={generalRes?.data?.common_informations}
                        layout={generalRes?.data?.common_informations_layout}
                      />
                    </div>
                    <BottomMenuLinks
                      datas={generalRes?.data?.bottom_menu_links}
                    />
                  </div>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12}>
                  <Typography
                    variant="h3"
                    component={'h2'}
                    className={clsx(
                      'pack__products-title',
                      packClasses.packProductTitle
                    )}
                  >
                    <CMSText
                      asText
                      data={packSettings?.data?.pack_content_title}
                      defaultText={t('texts:pack_single:pack_content_title')}
                    />
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    {currentPack?.packProducts.map((packProduct, index) => {
                      return (
                        <Grid key={index} item xs={6} lg={3}>
                          <PackProductCard
                            content={packProduct}
                            settings={{
                              ratio: aspectRatio,
                              cardWidth: cardWidth,
                              largeImgWidth: largeImgWidth,
                              isMobile: isMobile,
                              currentUrl: currentUrl,
                            }}
                          />
                        </Grid>
                      )
                    })}
                  </Grid>
                </Grid>
              </Grid>
            </Container>
          </Container>
        </section>
      </main>
      {packFullyLoaded && (
        <SizeModal
          open={openModal}
          handleClose={() => setOpenModal(false)}
          type={'pack'}
          text={packsTexts.data}
          stock={stock}
          products={currentPack?.packProducts}
          cart={cart}
          AddMultipleProductsToCart={AddMultipleProductsToCart}
          thumbRatio={aspectRatio}
          thumbWidth={thumbWidth}
          isMobile={isMobile}
          settings={generalRes?.data}
          selection={selection}
          setSelection={setSelection}
          takeback={takeback}
          takeBackLP={takeBackLP}
        />
      )}
      {showRelatedProducts && associations && (
        <PackRelatedProducts
          associations={associations}
          packs={packs}
          relatedProductsTitle={relatedProductsTitle}
          addToCartButtonOnAssociatedItem={addToCartButtonOnAssociatedItem}
          aspectRatio={aspectRatio}
          gridItemWidth={gridItemWidth}
          isFiveColumns={isFiveColumns}
          cardWidth={cardWidth}
          t={t}
          promotions={promotions}
          generalRes={generalRes?.data}
          singleProductRes={singleProductRes}
          stock={stock}
        />
      )}
      <ChangeStoreModal
        handleClose={handleCloseInStoreModal}
        open={openInStoreModal}
        doc={inStoreText}
        t={t}
      />
      <NoMixedBasketModal basket={basket} />
    </Layout>
  )
}

export async function getServerSideProps({ locale, previewData }) {
  const client = createClient({ previewData })
  const lang = setFullLocale(locale)

  const basket = await getSingleDocument(client, lang, 'basket')
  const generalRes = await getSingleDocument(client, lang, 'general')
  const takeback = await getSingleDocument(client, lang, 'take_back')
  const funnel = await getSingleDocument(client, lang, 'funnel')
  const packsTexts = await getSingleDocument(client, lang, 'packs')
  const packSettings = await getSingleDocument(client, lang, 'single_pack')
  const inStoreText = await getSingleDocument(client, lang, 'instore')
  const singleProductRes = await getSingleDocument(
    client,
    lang,
    'single_product'
  )
  const accountRes = await getSingleDocument(client, lang, 'account')
  const faqRes = await getSingleDocument(client, lang, 'faq')
  const banner = await getSingleDocument(client, lang, 'banner')

  return {
    props: {
      packsTexts,
      takeback,
      basket,
      generalRes,
      funnel,
      inStoreText,
      packSettings,
      singleProductRes,
      accountRes,
      faqRes,
      banner,
      i18nResources: await getTranslations(locale, ['texts']),
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Pack)
